import { TrustpilotReviewCard } from "components/TrustpilotReviewCard";
import type { TrustpilotReviewCardProps } from "components/TrustpilotReviewCard";
import type { ReactStoryblokComponent } from "types/storyblok";

const TrustpilotReviewAdapter = ({
  blok: { reviewText, author, authorsCountry, rating, avatarSrc },
  sbEditable,
}: ReactStoryblokComponent<TrustpilotReviewCardProps>) => (
  <TrustpilotReviewCard
    reviewText={reviewText}
    author={author}
    authorsCountry={authorsCountry}
    rating={rating}
    avatarSrc={avatarSrc}
    sbEditable={sbEditable}
  />
);

export default TrustpilotReviewAdapter;
